import { IUserBase } from 'src/entities/user';
import { invoiceDetailsRules } from './invoiceDetailsRules';
import { IValidationRule, required, emailFormat, phoneFormat } from './validations';

const getPersonalDetailsFields = () => {
    const emailField: keyof IUserBase = 'Email';
    const nameField: keyof IUserBase = 'Name';
    const phoneField: keyof IUserBase = 'Phone';

    return {
        Email: emailField,
        Name: nameField,
        Phone: phoneField,
    }
}

export const personalDetailsFields = getPersonalDetailsFields();

export const userDetailsRules = (isEmailRequired: boolean, isPhoneNumberRequired: boolean, isNameRequired: boolean, hasInvoice?: boolean) : IValidationRule[] => {
    const rules = [
        emailFormat(personalDetailsFields.Email),
        phoneFormat(personalDetailsFields.Phone),
    ];
    
    if (isEmailRequired) {
        rules.push(required(personalDetailsFields.Email));
    }
    if (isPhoneNumberRequired) {
        rules.push(required(personalDetailsFields.Phone));
    }
    if (isNameRequired) {
        rules.push(required(personalDetailsFields.Name));
    }

    if (hasInvoice) {
        return rules.concat(invoiceDetailsRules());
    }

    return rules;
} 